module.exports = __webpack_public_path__ + "img/flexible.09b047bf.png";